import React from "react";
import { Typography, TextField, IconButton, Theme } from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { Button, useLocale, useNotify, useTranslate } from "react-admin";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import TimerIcon from "@material-ui/icons/Timer";
import DeleteIcon from "@material-ui/icons/Delete";
import "./ShareLinkView.css";
import { useTheme } from "@material-ui/styles";
import {
  dateFnsLocaleMap,
  ProLogsLocale,
} from "../../../common/util/localization";
import { enUS } from "date-fns/locale";

interface Props {
  linkUrl: string;
  onDeleteClick: () => void;
  validFrom?: string | undefined;
  validTo?: string | undefined;
}

export const ShareLinkView = ({
  onDeleteClick,
  validFrom,
  validTo,
  linkUrl,
}: Props) => {
  const notify = useNotify();
  const theme: Theme = useTheme();
  const translate = useTranslate();
  const locale = useLocale() as ProLogsLocale;
  const dateFnsLocale = !!dateFnsLocaleMap[locale]
    ? dateFnsLocaleMap[locale]
    : enUS;

  return !!validFrom && !!validTo && !!linkUrl ? (
    <div className="share-link">
      <TextField
        variant="outlined"
        value={linkUrl}
        size="small"
        margin="dense"
      />
      <IconButton
        style={{ color: theme.palette.error.main }}
        onClick={onDeleteClick}>
        <DeleteIcon fontSize="small" />
      </IconButton>
      <div className="share-link-validity">
        <TimerIcon fontSize="small" />
        <Typography variant="caption">
          {format(parseISO(validFrom), "LLL do p", { locale: dateFnsLocale })}
        </Typography>
        {" - "}
        <Typography variant="caption">
          {format(parseISO(validTo), "LLL do p", { locale: dateFnsLocale })}
        </Typography>
      </div>
      <Button
        label={translate("resources.locations-current.labels.copyLink")}
        onClick={async () => {
          await navigator.clipboard.writeText(linkUrl);
          notify(
            "resources.locations-current.labels.linkCopiedSuccessfully",
            "info"
          );
        }}>
        <FileCopyIcon />
      </Button>
    </div>
  ) : null;
};
